import { ref, computed } from '@nuxtjs/composition-api';
import debounce from 'lodash/debounce'
export default function useRoamingPrices(appContext) {
  const hubbleClient = appContext.$hubble;
  const paymentTypeModel = ref() // MV or PAYG
  const fromCountryModel = ref({}) // default selected Danmark
  const toCountryModel = ref({ country: 'Danmark', zone: 'Danmark Zone' }) // default selected Danmark
  const paymentTypeItems = [{ text: 'Månedspris', value: 'MV' }, { text: 'Stk. pris (pr. opkald/sms/mms)', value: 'PAYG' }]
  const fromCountryDisabled = ref(true)
  const toCountryDisabled = ref(true)

  const prices = ref(null)
  const localPrices = ref(null)

  const isDenmarkToDenmark = ref(false)
  const isSyria = ref(false)

  const countries = ref(null)

  const denmarkToDenmarkCheck = () => {
    if (fromCountryModel.value.country === 'Danmark' && toCountryModel.value.country === 'Danmark') {
      isDenmarkToDenmark.value = true
      return true
    }
    isDenmarkToDenmark.value = false
    return false
  }

  const syriaCheck = () => {
    if (fromCountryModel.value.country === 'Syrien' || toCountryModel.value.country === 'Syrien') {
      isSyria.value = true
      return true
    }
    isSyria.value = false
    return false
  }


  const resetData = () => {
    isSyria.value = false
    isDenmarkToDenmark.value = false
    prices.value = null
    localPrices.value = null
  }
  const getData = (from, to) => hubbleClient.roamingPrices.getPrices({
    fromCountry: from.value?.country,
    fromZone: from.value?.zone,
    toCountry: to.value?.country,
    toZone: to.value?.zone,
    roamingUserType: paymentTypeModel?.value
  })
  const getCountries = async () => {
    const res = await hubbleClient.roamingPrices.getCountries()
    countries.value = res.data
    return countries.value
  }

  // eslint-disable-next-line complexity
  const fetchCountryRoamingData = async () => {
    console.log('I reach in fetchCountryRoamingData')
    if (!toCountryModel.value || !fromCountryModel.value) { return }
    resetData()

    if (denmarkToDenmarkCheck()) {
      return
    }

    if (syriaCheck()) {
      return
    }

    // prices
    try {
      const res1 = await getData(fromCountryModel, toCountryModel)
      prices.value = res1.data
      // local prices
      if (fromCountryModel.value?.country !== toCountryModel.value?.country && fromCountryModel.value?.country !== 'Danmark') {
        const res = await getData(fromCountryModel, fromCountryModel)
        localPrices.value = res.data
      } else {
        localPrices.value = null
      }
    } catch (err) {
      console.error('Problem fetching data', err)
    }
  }

  const onPaymentTypeChange = async (e) => {
    paymentTypeModel.value = e.value
    if (!e.toCountryDisabled) {
      await fetchCountryRoamingData()
    }
  }


  const onCountryChange = debounce(async (e) => {
    if (e.method === 'from') {
      fromCountryModel.value = e.value
    } else {
      toCountryModel.value = e.value
    }
    await fetchCountryRoamingData()
  }, 300)
  const countryItems = computed(() => {
    console.log('countries in computed', countries.value)
    return countries?.value?.map(item => {
      return {
        text: item.country,
        value: item,
        default: item.country === 'Danmark'
      }
    })
  })


  return {
    toCountryDisabled,
    paymentTypeItems,
    fromCountryDisabled,
    countryItems,
    getCountries,
    countries,
    fetchCountryRoamingData,
    getData,
    isSyria,
    isDenmarkToDenmark,
    prices,
    localPrices,
    fromCountryModel,
    paymentTypeModel,
    toCountryModel,
    onCountryChange,
    onPaymentTypeChange
  }
}
